var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.canUpdate)?_c('UserProfileUpdate',{attrs:{"user-id":_vm.userId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }